import AjaxEntity from './base.js';
import { doXhr } from '../../../remote/request.js';

/**
 * @typedef {{ product_id: number|string; variant_id?: number|string; }} MpApiLookupItem
 * @typedef {{ items: MpApiLookupItem[]; }} MpApiLookupData
 * @typedef {{ items: MpApiLookupItem[], count_items: number; }} MpApiLookupResponseData
 * @typedef {{ status: number; error?: string; data?: MpApiLookupResponseData }} MpApiLookupResponse
 */

export default class Inventory extends AjaxEntity {

	static get NAME() {
		return 'Inventory';
	}

	availability_add(data) {
		return doXhr(this.endpoints.availability_add, { method: 'POST', data });
	}

	availability_delete(data) {
		return doXhr(this.endpoints.availability_delete, { method: 'POST', data });
	}

	userlist_set(data) {
		return doXhr(this.endpoints.userlist_set, { method: 'POST', data });
	}

	userlist_clear(data) {
		return doXhr(this.endpoints.userlist_clear, { method: 'POST', data });
	}
}
